import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { authModel } from "../../model/AuthModel";
import { AuthPaths } from "./AuthPaths";

export const AuthLogoutButton = (props: any) => {
  const sx: any = props.sx;

  const appName: string = props.appName;
  const navigate = useNavigate();

  const handleLogout = () => {
    authModel.setEmail(undefined);
    authModel.setJwtToken(null);
    navigate(AuthPaths.logoutRoute(appName));
  };

  return (
    <Button
      variant="text"
      color="primary"
      size="small"
      sx={sx}
      onClick={handleLogout}
    >
      Sign Out
    </Button>
  );
};
